export const getPriceDecimals = (value) => {
    const absValue = Math.abs(Number(value) || 0);
    if (absValue === 0) {
        return 2;
    }
    if (absValue >= 1) {
        return 3;
    }
    if (absValue >= 0.001) {
        return 6;
    }
    return 9;
};

export const howManyDecimals = (numberOfDecimals, value) => {
    if (numberOfDecimals) {
        // specified decimals already
        return numberOfDecimals;
    }
    const absValue = Math.abs(Number(value) || 0);
    if (absValue === 0 || absValue >= 10) {
        return 2;
    }
    if (absValue >= 1) {
        return 3;
    }
    if (absValue >= 0.001) {
        return 6;
    }
    return 9;
};

export const formatSmartPrice = (value = "") => {
    const numeric = Number(value) || 0;
    const decimals = getPriceDecimals(numeric);
    return numeric.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: decimals,
    });
};

export const getFormattedAmount = (
    value = "",
    shouldFormat = true,
    numberOfDecimals
) => {
    const numeric = Number(value) || 0;
    const decimals = howManyDecimals(numberOfDecimals, numeric);
    if (shouldFormat) {
        return numeric.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: Math.max(2, decimals),
        });
    }
    return Number(numeric.toFixed(decimals));
};

export const getFormattedPercentage = (value = "", numberOfDecimals) => {
    const numeric = Number(value) || 0;
    if (!Number.isFinite(numeric)) {
        return "0.0%";
    }
    let prefix = "";
    if (numeric > 0) prefix = "+";
    if (numeric < 0) prefix = "-";
    return `${prefix}${Math.abs(numeric).toLocaleString("en-US", {
        minimumFractionDigits: 1,
        maximumFractionDigits:
            numberOfDecimals || (Math.abs(numeric) >= 1 ? 2 : 4),
    })}%`;
};
